module.exports = __webpack_public_path__ + "img/jiuquan.c8ca7539.jpg";